export default __webpack_public_path__ + "assets/tumblr.ac083c8e.svg";